import { combineReducers } from "redux";
import { Holiday } from "../types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { CREATE_HOLIDAY_REQUEST, DELETE_HOLIDAY_REQUEST, FETCH_HOLIDAYS_REQUEST } from "./constants";
import { Action } from "./types";

function items(state: Holiday[] = [], action: Action): Holiday[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_HOLIDAYS_REQUEST):
      return action.payload;

    case getSuccessActionType(DELETE_HOLIDAY_REQUEST):
      return state.filter((holiday) => holiday.id !== action.data.holidayId);

    case getSuccessActionType(CREATE_HOLIDAY_REQUEST):
      return [...state, action.payload];

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_HOLIDAYS_REQUEST:
      return true;
    case getSuccessActionType(FETCH_HOLIDAYS_REQUEST):
    case getFailureActionType(FETCH_HOLIDAYS_REQUEST):
      return false;

    case CREATE_HOLIDAY_REQUEST:
      return true;
    case getSuccessActionType(CREATE_HOLIDAY_REQUEST):
    case getFailureActionType(CREATE_HOLIDAY_REQUEST):
      return false;

    case DELETE_HOLIDAY_REQUEST:
      return true;
    case getSuccessActionType(DELETE_HOLIDAY_REQUEST):
    case getFailureActionType(DELETE_HOLIDAY_REQUEST):
      return false;

    default:
      return state;
  }
}

export const holidays = combineReducers({ items, isFetching });
